<template>
    <BaseModal
        :show="show"
        title="Set Default App"
        confirmText="Yes"
        cancelText="No"
        :useTimer="true"
        @confirm="$emit('confirm')"
        @cancel="$emit('cancel')"
        ref="baseModal"
    >
        Do you want to set <strong>{{ appName }}</strong> as the default app<br>
        to auto launch after <strong>{{ params.autoLaunchTimeout }}s</strong> in inactivity?
    </BaseModal>
</template>

<script setup>
import {ref} from 'vue';
import BaseModal from './BaseModal.vue';
import {params} from "@/systemInfo.js";

function getButtons() {
    return [confirmButton.value, cancelButton.value].filter(Boolean);
}

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    appName: {
        type: String,
        default: ''
    }
});

const emit = defineEmits(['confirm', 'cancel']);
const baseModal = ref(null);
const confirmButton = ref(null);
const cancelButton = ref(null);

// Expose the animateModalClose method from BaseModal
defineExpose({
    getButtons,
    animateModalClose: () => baseModal.value?.animateModalClose()
});
</script>